import type { ReactNode } from "react";
import { Container, Stack, Text } from "@chakra-ui/react";
import { PublicSectionHeader } from "@/shared/public-ui";

type PublicFeedbackPageLayoutProps = {
  children: ReactNode;
};

export default function PublicFeedbackPageLayout({
  children,
}: PublicFeedbackPageLayoutProps) {
  return (
    <Container
      maxW="container.md"
      px={{ base: "4", md: "8" }}
      pt={{ base: "8", md: "12" }}
      mb={{ base: "12", md: "16" }}
    >
      <Stack gap={{ base: "6", md: "8" }} align="stretch">
        <PublicSectionHeader
          headingLevel={1}
          align="center"
          title={
            <>
              Share professional{" "}
              <Text as="span" color="moveon.primary">
                feedback
              </Text>
            </>
          }
          description="Share specific professional feedback privately. Short, concrete examples are most useful."
        />
        {children}
      </Stack>
    </Container>
  );
}
